import {IComponentOptions, IScope, ITimeoutService} from "angular";
import {Credit} from "../model/Credit";
import {Assessment} from "../model/Assessment";
import {Application} from "../model/Application";
import {IReferenceDataItem, ReferenceData} from "../reference-data/reference-data.service";
import {ApplicationService} from "../application/application.service";
import {StudyUnitService} from "../study-unit/study-unit.service";
import {CPARSearchRequest} from "../model/CPARSearchRequest";
import "./assessment.less";
import {CparService} from "../cpar/cpar.service";
import * as _ from "lodash";
import {PriorCourseUnit} from "../model/PriorCourseUnit";
import {PriorCourse} from "../model/PriorCourse";

interface AssessmentMessage {
    senderEmail: string;
    senderName: string;
    created: string;
    text: string;
}

class AssessmentComponentController {

    public form: any;
    public assessment: Assessment;
    public application: Application;
    public assessmentHistories: any[];

    public assessmentTypes: IReferenceDataItem[];
    public specifiedCreditTypes: IReferenceDataItem[];
    public unspecifiedCreditTypes: IReferenceDataItem[];
    public unitLevels: IReferenceDataItem[];

    public showErrors: boolean = false;
    public fieldsEnabled: boolean;
    public actionsEnabled: boolean;
    public priorUnits: any[] = [];
    public firebaseDatabasePath: string;
    public messages: AssessmentMessage[];

    public mostRecentHistory;
    public selectedCourseCodeValue: string;

    // private precedentValidityStart: string;
    // private precedentValidityEnd: string;
    // private showPrecedentInfo: boolean;

    private MIN_EXPIRY_OFFSET: number = 1;
    private MAX_EXPIRY_OFFSET: number = 12;

    /* @ngInject */
    constructor(private $log: ng.ILogService,
                private $timeout: ITimeoutService,
                private $scope: IScope,
                private applicationService: ApplicationService,
                private $uibModal: any,
                private studyUnitService: StudyUnitService,
                private cparService: CparService,
                private toaster: any,
                private referenceData: ReferenceData) {
        this.assessmentTypes = this.referenceData.getAll("AssessmentType");
        this.specifiedCreditTypes = this.referenceData.getAll("SpecifiedCreditType");
        this.unspecifiedCreditTypes = this.referenceData.getAll("UnspecifiedCreditType");
        this.unitLevels = this.referenceData.getAll("UnitLevel");
    }

    public $onInit() {
        this.$log.debug("AssessmentComponentController.$onInit()");
        this.getPriorUnitCodes();
        this.firebaseDatabasePath = `assessment-messages/${this.assessment.id}`;
        this.refreshHistory();
        this.initSelectedCourse();
        // if (this.assessment.precedentId) {
        //     this.fetchPrecedentInfo();
        // }
    }


    public getPriorUnitCodes() {
        const unitCodes = _.flatMap(this.application.priorStudies, (priorStudy) => {
            _.forEach(priorStudy.units, (unit) => {
                if (priorStudy.institution === undefined) {
                    unit.institutionName = priorStudy.tempInstitution;
                } else {
                    unit.institutionCode = priorStudy.institution.code;
                    unit.institutionName = priorStudy.institution.name;
                }
                unit.display = unit.unitCode + " " + unit.unitTitle;
            });

            return priorStudy.units;
        });

        this.$log.debug("getPriorUnitCodes:", unitCodes);
        this.priorUnits = unitCodes;
    }

    public $onChanges(changesObj) {
        this.$log.debug("AssessmentComponentController.$onChanges()", changesObj);

        if (changesObj.assessment) {
            this.assessment = changesObj.assessment.currentValue;
            this.$timeout(() => {
                this.$scope.$broadcast("rzSliderForceRender");
            });
            this.refreshHistory();
            this.initSelectedCourse();
        }
    }

    /**
     * Initialize or auto-select the course for single-select radio.
     * Handles undefined major by defaulting to empty string.
     */
    private initSelectedCourse() {
        if (this.assessment.courseCodes && this.assessment.courseCodes.length > 0) {
            this.selectedCourseCodeValue = this.assessment.courseCodes[0];
        } else if (this.application.coursesApplied && this.application.coursesApplied.length == 1) {
            // Auto-select if there is only one course
            const course = this.application.coursesApplied[0];
            this.selectedCourseCodeValue = course.course.code + '-' + (course.major || '');
            this.assessment.courseCodes = [this.selectedCourseCodeValue];
        }
    }


    // public searchPrecedent(application: Application, assessment: Assessment) {
    //     this.$log.debug("searchPrecedent", application, assessment);
    //
    //     this.$uibModal.open({
    //         component: "searchPrecedentModal",
    //         backdrop: 'static',
    //         keyboard: false,
    //         resolve: {
    //             application: () => application,
    //             assessment: () => assessment
    //         },
    //         size: "lg"
    //     }).result.then((precedentInfo) => {
    //         this.$log.info("Applied precedent: %o", precedentInfo);
    //     }, (reason) => {
    //         this.$log.info("modal dismissed: " + reason);
    //     });
    // }

    // public resetPrecedent() {
    //     this.assessment.precedentId = null;
    //     this.assessment.precedentStatus = null;
    //     this.assessment.credits = [];
    //     this.assessment.credits.push(new Credit());
    // }

    public isSearchEnabled(assessment: Assessment): boolean {
        return assessment.status === "IN_PROGRESS";
    }

    public specifiedCreditTypeChanged(credit: Credit) {
        this.$log.debug("specifiedCreditTypeChanged");
        if (credit.specifiedCreditType === "PRECLUSION") {
            credit.creditPoints = 0;
        } else if (credit.monashUnitCode) {
            this.studyUnitService.search(credit.monashUnitCode).then((response: any) => {
                if (response[0] && response[0].achievableCreditPoints) {
                    this.$log.debug("Found unit: %o", response[0]);
                    credit.creditPoints = response[0].achievableCreditPoints;
                }
            });
        }
    }

    private assessmentTypeChange(credit: Credit) {
        this.$log.log("Assessment type changed");
        const type = credit.type;
        if (type !== "UNSPECIFIED_CREDIT") {
            this.clearUnspecifiedCreditTypeFields(credit);
        }
        if (type !== "SPECIFIED_CREDIT") {
            this.clearSpecifiedCreditTypeFields(credit);
        }
    }

    private searchUnit(unitName) {
        const units = this.priorUnits.filter((el) => {
            return el.unitTitle.toLowerCase().indexOf(unitName) > -1;
        });

        let i = 0;
        this.priorUnits.forEach((unit) => {
            if (unit.unitId === undefined || unit.unitId === null) {
                unit.unitId = i;
                i++;
            }

        });
        this.$log.log(units);
        return units;
    }

    private clearUnspecifiedCreditTypeFields(credit: Credit) {
        credit.unitLevel = null;
        credit.discipline = null;
    }

    private clearSpecifiedCreditTypeFields(credit: Credit) {
        credit.specifiedCreditType = null;
        credit.monashUnitCode = null;
        credit.monashUnitVersion = null;
    }

    private refreshHistory() {
        this.applicationService.getAssessmentHistoriesByApplicationIdAndAssessmentId(this.application.id,
            this.assessment.id).then((histories: any) => {
            this.assessmentHistories = histories;
            this.mostRecentHistory = this.getMostRecentHistory(histories);
        });
    }

    private getMostRecentHistory(assessmentHistories: any[]) {
        if (!assessmentHistories || assessmentHistories.length <= 0) {
            return null;
        }

        return assessmentHistories[assessmentHistories.length - 1];
    }

    // private togglePrecedentInfo() {
    //     if (!this.showPrecedentInfo) {
    //         this.fetchPrecedentInfo().then((response) => this.showPrecedentInfo = true);
    //     } else {
    //         this.showPrecedentInfo = false;
    //     }
    // }

    // private fetchPrecedentInfo() {
    //     this.$log.debug("Fetching precedent info for precedent %s", this.assessment.precedentId);
    //     const cparSearchRequest = new CPARSearchRequest();
    //     cparSearchRequest.precedentId = this.assessment.precedentId;
    //     return this.cparService.searchCPARPrecedents(cparSearchRequest).then((results: any) => {
    //         const cparSearchResponse = results;
    //         if (cparSearchResponse._embedded.items.length > 0) {
    //             const precedent = cparSearchResponse._embedded.items[0];
    //             this.precedentValidityStart = precedent.validityPeriodStartDate;
    //             this.precedentValidityEnd = precedent.validityPeriodEndDate;
    //         } else {
    //             this.precedentValidityStart = "No data available";
    //             this.precedentValidityEnd = "No data available";
    //         }
    //     }).catch((response) => {
    //         this.precedentValidityStart = "No data available";
    //         this.precedentValidityEnd = "No data available";
    //     });
    // }

    private isAddCreditButtonDisabled(){
        return this.assessment.courseCodes === undefined
                    || this.assessment.courseCodes == null
                    || this.assessment.courseCodes.length == 0;
    }

    public onAssessmentCourseSelected() {
        this.assessment.courseCodes = [this.selectedCourseCodeValue];
    }

    private addCreditModal(credit: Credit) {
        const modalInstance = this.$uibModal.open({
            animation: true,
            component: "credit",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                assessment: () => this.assessment,
                application: () => {
                    console.log("inside assessment component")
                    console.log(this.application)
                    return this.application
                },
                priorUnits: () => this.priorUnits,
                fieldsEnabled: () => this.fieldsEnabled,
                showErrors: () => this.showErrors,
                credit: () => credit,
            },
            size: 'lg'

        });

        modalInstance.result.then((result) => {
            const index = this.assessment.credits.indexOf(result.$value);
            if (index >= 0) {
                this.assessment.credits[index] = result.$value;
            } else {
                this.assessment.credits.push(result.$value);
            }
        }, () => {
            this.$log.info("modal-component dismissed at: " + new Date());
        });
    }

    private delete(credit: Credit) {
        const index = this.assessment.credits.indexOf(credit);
        this.assessment.credits.splice(index, 1);
    }
}

export const AssessmentComponent: IComponentOptions = {
    bindings: {
        header: "@?",
        assessment: "<",
        application: "=",
        fieldsEnabled: "<",
        showErrors: "<"
    },
    controller: AssessmentComponentController,
    template: require("./assessment.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/assessment.component.ts